// extracted by mini-css-extract-plugin
module.exports = {"completeMsg":"OrderComplete_completeMsg__CyHlq"};